import { StoredMediaServiceOutput, } from './StoredMediaServiceOutput';
import { StoredMediaStore } from './StoredMediaStore';
function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
export class StoredMediaService {
    static instance;
    output;
    store;
    nextId;
    static getInstance() {
        if (!StoredMediaService.instance) {
            StoredMediaService.instance = new StoredMediaService();
        }
        return StoredMediaService.instance;
    }
    static getNotificationInterface() {
        return StoredMediaService.getInstance();
    }
    static getOutput() {
        return StoredMediaServiceOutput.getReactiveOutput();
    }
    constructor() {
        this.output = new StoredMediaServiceOutput();
        this.store = new StoredMediaStore();
        this.nextId = this.store.getNextImageId();
    }
    notifyAddImage(file) {
        void this.addImage(file);
    }
    notifyRemoveImage(id) {
        const images = this.output.getImages();
        const image = images.find((i) => i.id === id);
        if (image) {
            URL.revokeObjectURL(image.objectUrl);
        }
        this.output.removeImage(id);
        this.store.removePersistedImage(id);
    }
    async addImage(file) {
        const [objectUrl, bitmap, dataUrl] = await Promise.all([
            Promise.resolve(URL.createObjectURL(file)),
            createImageBitmap(file),
            fileToDataUrl(file),
        ]);
        const image = {
            id: `image:${this.nextId++}`,
            name: file.name,
            objectUrl,
            bitmap,
        };
        this.output.addImage(image);
        this.store.persistImage(image.id, image.name, dataUrl);
        return image;
    }
    getImageBitmap(id) {
        return this.output.getImages().find((i) => i.id === id)?.bitmap;
    }
    isImageSourceId(id) {
        if (!id)
            return false;
        return id.startsWith('image:') || id.startsWith('bg:');
    }
    async restoreImagesForScenes(scenes) {
        const currentImages = this.output.getImages();
        const neededIds = new Set();
        for (const scene of scenes) {
            if (scene.backgroundSourceId) {
                neededIds.add(scene.backgroundSourceId);
            }
            for (const slot of scene.videoSlots) {
                if (this.isImageSourceId(slot.sourceId)) {
                    neededIds.add(slot.sourceId);
                }
            }
        }
        for (const imageId of neededIds) {
            if (currentImages.find((i) => i.id === imageId))
                continue;
            const persisted = this.store.getPersistedImage(imageId);
            if (!persisted)
                continue;
            try {
                const resp = await fetch(persisted.dataUrl);
                const blob = await resp.blob();
                const [bitmap, objectUrl] = await Promise.all([
                    createImageBitmap(blob),
                    Promise.resolve(URL.createObjectURL(blob)),
                ]);
                this.output.addImage({
                    id: imageId,
                    name: persisted.name || 'Image',
                    objectUrl,
                    bitmap,
                });
            }
            catch {
                this.store.removePersistedImage(imageId);
            }
        }
    }
}
